<template>
    <article class="card-tour">
        <NuxtLink :to="`${url}${item.id}`" class="card-link image-link">
            <div class="image-wrapper">
                <mess-image ref="image" :src="heroImage" placeholder loading="lazy" :width="350" />
                <SvgsSpeakers v-if="hasAudio" />
            </div>
        </NuxtLink>

        <div class="content">
            <NuxtLink :to="`${url}${item.id}`" class="card-link">
                <div class="header">
                    <h3 class="card-header">{{ item.fields.Name }}</h3>
                    <p v-if="tag" class="gray-tag">{{ tag }}</p>
                </div>
            </NuxtLink>

            <div class="footer">
                <GlobalUserActionButton list="ohcFavoriteTours" :item="item" />
                <p v-if="sitesNumber">{{ sitesNumber }}</p>
            </div>
        </div>
    </article>
</template>

<script setup>
    const { getImageFromArray } = useImageUrl();

    const props = defineProps({
        item: {
            type: Object,
            required: true,
        },
    });

    const { item } = toRefs(props);

    const tag = computed(() => {
        return item?.value?.fields?.['Type'] === 'Trail' ? 'Neighborhood' : 'Themed';
    });

    const hasAudio = computed(() => {
        return item?.value?.fields?.['Type'] === 'Trail' ? true : false;
    });

    const sitesNumber = computed(() => {
        const type = item?.value?.fields?.['Type'];
        let num = 0;
        if (type === 'Trail') num = item?.value?.fields?.['Points of Interest']?.length;
        else num = item?.value?.fields?.['Organizations']?.length;
        if (num > 0) {
            return num > 1 ? `${num} sites` : `${num} site`;
        }
        return false;
    });

    const heroImage = computed(() => {
        if (item?.value?.fields?.['Hero image']) {
            return getImageFromArray(item.value.fields['Hero image'], 0);
        }
        return 'https://images.openhousechicago.org/email-header.png';
    });

    const route = useRoute();
    const url = computed(() => {
        if (route.path.includes('archive')) return '/archive/2023/tours/';
        else return '/itineraries/';
    });
</script>

<style lang="scss" scoped>
    .card-tour {
        border: 1px solid #d1d1d1;
        display: flex;
        height: 100%;
        background-color: $white;
        position: relative;
        .card-link {
            display: block;

            &.image-link {
                width: 35%;
                position: absolute;
                top: 0;
                left: 0;
                height: 100%;
                .image-wrapper {
                    height: 100%;
                }
            }
            &:not(.image-link) {
                width: 100%;
            }
        }

        .image-wrapper {
            position: relative;
            img {
                height: 100%;
                width: 100%;
                object-fit: cover;
                object-position: center;
            }
            svg {
                position: absolute;
                left: 15px;
                bottom: 15px;
            }
        }

        .content {
            width: 65%;
            padding: 15px;
            margin-left: auto;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }

        .footer {
            display: flex;
            justify-content: space-between;
            align-items: center;
            font-size: 14px;
            font-weight: 350;
            line-height: 15px;
            margin-top: 15px;
        }

        @media (min-width: $tablet) {
            flex-direction: column;

            .card-link.image-link {
                position: relative;
                width: 100%;
                height: 200px;
                flex-shrink: 0;
            }

            .content {
                width: 100%;
                margin-left: 0;
                height: 100%;
            }
        }
    }
</style>
